import { BlockTitle } from "@blocks/Blocks";
import SCAOrganiserDetails from "@sca/components/SCAOrganiserDetails";

import ACRASection from "./ACRASection";
import BainSection from "./BainSection";
import BusinessTimesSection from "./BusinessTimesSection";
import CitigateSection from "./CitigateSection";
import DeloitteSection from "./DeloitteSection";
import EYSection from "./EYSection";
import HeidrickSection from "./HeidrickSection";
import ISCASection from "./ISCASection";
import KPMGSection from "./KPMGSection";
import NUSBusinessSchoolSection from "./NUSBusinessSchoolSection";
import PartnersDetails from "./PartnersDetails";
import PwCSection from "./PwCSection";
import SGXSection from "./SGXSection";
import SIDSection from "./SIDSection";
import StandardCharteredSection from "./StandardCharteredSection";

/**
 * Component to render Partners Page
 */
const PartnersPage = (): React.ReactElement => {
  return (
    <div data-testid="partners-page-component" className="font-public-sans">
      <BlockTitle
        text="Partners"
        rootClassName="text-4xl md:text-6xl lg:text-8xl font-medium mb-6"
      />

      <SCAOrganiserDetails />

      <PartnersDetails />

      <BusinessTimesSection />

      <ISCASection />

      <SIDSection />

      <StandardCharteredSection />

      <ACRASection />

      <SGXSection />

      <BainSection />

      <NUSBusinessSchoolSection />

      <DeloitteSection />

      <EYSection />

      <HeidrickSection />

      <KPMGSection />

      <PwCSection />

      <CitigateSection />
    </div>
  );
};

export default PartnersPage;
